<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> Configurações de Encurtador </h3>
        <small>Confgurações da integração com o NxEncurtador para encurtar Links.</small>
      </div>
    </div>
    <ModeloAdd v-if="showAdd" ref="ModeloAdd" v-on:Back="onBack" />
    <ModeloList v-else ref="ModeloList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ModeloAdd from './components/add/campanhaencurtadoradd.vue'
import ModeloList from './components/list/campanhaEncurtadorConfigList.vue'

export default {
  name: 'CampaignEncurtador',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ModeloAdd,
    ModeloList
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ModeloAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/encurtador/encurtadorconfig.vue